import React, { useEffect, useState } from "react";
import OrgList from "../../molecules/OrgList";
import InviteOrg from "../../molecules/InviteOrg";
import Container from "@mui/material/Container";
import { INotification } from "../../interfaces/General";
import {
  Organization,
  useGetOrganizationsLazyQuery,
} from "../../generated/graphql";

const MaintainerView = () => {
  const [orgList, setOrgList] = useState<Organization[]>([]);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState<INotification>({
    message: "",
    open: false,
    type: "info",
  });
  const [getOrganizationList, { data, error }] = useGetOrganizationsLazyQuery({
    onCompleted() {
      setOrgList(data?.getOrganizations as Organization[]);
      setLoading(false);
    },
    onError() {
      setNotification({
        message: error?.message as string,
        open: true,
        type: "error",
      });
      setLoading(false);
    },
    fetchPolicy: "no-cache",
  });
  useEffect(() => {
    setLoading(true);
    getOrganizationList();
  }, []);
  return (
    <Container>
      <InviteOrg orgList={orgList} setOrgList={setOrgList} />
      <OrgList orgList={orgList} setOrgList={setOrgList} />
    </Container>
  );
};

export default MaintainerView;
